const replacePipe = (message) => {
  const newMessage = message?.replaceAll('|', '');
  return newMessage;
};

export default replacePipe;
